import { Portal, Toaster, createToaster } from '@chakra-ui/react';
import { ToastItem } from '@monetize/types/app';
import { useEffect } from 'react';
import { useAtomValue } from 'jotai';
import { activeToastState } from '../../store/global.store';
import { MBox, MToast } from '../Monetize';

export const toaster = createToaster({
  placement: 'top-end',
  pauseOnPageIdle: true,
});

const AppToastWrapper = () => {
  const toastData = useAtomValue(activeToastState);

  useEffect(() => {
    if (!toastData) {
      return;
    }

    toaster.create({
      // zag requires a `type`; an explicit `undefined` overrides its default
      // and throws on render, so fall back the way v2's `status` did.
      type: toastData.severity ?? 'info',
      duration: toastData.life,
      meta: toastData,
    });
  }, [toastData]);

  return (
    <Portal>
      <Toaster toaster={toaster} insetInline={{ mdDown: '4' }} gap="4">
        {({ id, meta }) => (
          /*
           * No `Toast.Root` (its absolute stacking would replace this group's
           * flex layout), so restore what v2 wrapped custom toasts in: a
           * `role="status"` live region that pauses on hover. `pointerEvents`
           * keeps the toast clickable while a modal sets `pointer-events:
           * none` on the body.
           */
          <MBox
            role="status"
            aria-atomic="true"
            pointerEvents="auto"
            onMouseEnter={() => toaster.pause(id)}
            onMouseLeave={() => toaster.resume(id)}
          >
            <MToast
              id={id}
              onClose={(toastId) => toastId && toaster.dismiss(toastId)}
              {...(meta as ToastItem)}
            />
          </MBox>
        )}
      </Toaster>
    </Portal>
  );
};

export default AppToastWrapper;
